import { startOfMonth, endOfMonth, subMonths, format } from 'date-fns';

const f = (d) => format(d, 'yyyy-MM-dd');

// Returns the last `n` calendar months (oldest first) ending at `endRef`,
// each as { label, from, to } with 'yyyy-MM-dd' bounds. Used for snapshot sparklines.
export function trailingMonths(n = 6, endRef = new Date()) {
  const out = [];
  for (let i = n - 1; i >= 0; i--) {
    const d = subMonths(endRef, i);
    out.push({ label: format(d, 'MMM'), from: f(startOfMonth(d)), to: f(endOfMonth(d)) });
  }
  return out;
}
